import type { ReactNode } from "react";
import { reviewTextForDisplay } from "./review-text";

/** Only presentation text slots: never traverse elements or rewrite their value, href, ID or event props. */
export function reviewContentForDisplay(value: ReactNode): ReactNode {
  if (typeof value === "string") return reviewTextForDisplay(value);
  if (Array.isArray(value)) return value.map(reviewContentForDisplay);
  return value;
}
